export default {
  home: {
    topTitle: '想要',
    loopTitlesTop: [
        '跨境电商业务',
        '挖掘更多',
        '成为类目',
        '打造家喻户晓'
    ],
    loopTitlesBottom: [
      '快人一步',
      '增长点',
      '头部卖家',
      '的品牌'
    ],
    mjInfo1: '携手 HARMONY 入驻北美亚马逊自营渠道',
    mjInfo2: '精准布局海外销售渠道，实现前所未有的高速增长。',
    getSchemeButton: '获取解决方案',
    dataTop: '国内全品牌合作方',
    dataIntroduce: 'HARMONY 全国领先的 Amazon VC 渠道分销平台',
    dataIntroduceDetails1: '与 Amazon 超 8 年 VC 顶级资源合作关系',
    dataIntroduceDetails2: '提供销售和供应链全业务流程解决方案，帮助您实现业务规模化增长',
    dataNumberTitle: [
      {
        title: '入驻品牌',
        number: 1000,
        prefix: '',
        suffix: '+'
      },
      {
        title: '年订单金额',
        number: 9,
        prefix: '$',
        suffix: '亿'
      },
      {
        title: '单品牌年 GMV',
        number: 3500,
        prefix: '$',
        suffix: '万'
      },
      {
        title: '销量提升率',
        number: 47.6,
        prefix: '',
        suffix: '%'
      }
    ],
    logisticsInfo: [
        '链接全球资源',
        '助力中国品牌畅销全球',
        '依托 HARMONY 平台链接全球渠道与供应链资源，',
        '助力中国企业跨境业务加速发展。',
    ],
    dataLogisticsTitle: [
      {
        title: 'VC 提货准时率',
        number: 90,
        prefix: '',
        suffix: '%',
        icon: 'punctuality'
      },
      {
        title: '按时送达率',
        number: 99.9,
        prefix: '',
        suffix: '%',
        icon: 'deliver'
      },
      {
        title: '库存精度',
        number: 99.5,
        prefix: '',
        suffix: '%',
        icon: 'accuracy'
      }
    ],
    customerProblemTitle: '您是否正在面临这些',
    customerProblemTitleColor: '挑战？',
    customerProblem: [
      {
        title: '流量获取难，广告成本高居不下?',
        painSpot: '痛点',
        ism: 'HARMONY 解决方案',
        url: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/challenge/challenge_1_576x480.png',
        painSpotText: `杭州某类目品牌商，SC 运营的主力产品停滞在小类目 BS20 名左右，广告成本花费大。`,
        ismText: '品牌商切入 VC 后，通过 BD（Best Deal）活动连秒的优势，突破流量瓶颈。在 HARMONY 账号经理的支持下，历时 2 个月的时间，自然日销量提升 3 倍，活动日销量提升 9 倍，广告花费占比下降 3%，最终取得小类目 BS 的成绩，在该类目下市场占比达到 3.96%。'
      },
      {
        title: '海外仓履约能力不足，造成高额罚款?',
        painSpot: '痛点',
        ism: 'HARMONY 解决方案',
        url: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/challenge/challenge_2_576x480.png',
        painSpotText: `深圳 3C 类目某品牌商，依赖第三方海外仓导致亚马逊 VC 订单履约率严重偏低，导致承担大量亚马逊平台违约罚金，显著侵蚀利润空间。`,
        ismText: '转入 HARMONY 云仓后，采购订单（PO）当天提货履约率显著提升至 90% 以上，彻底消除了亚马逊平台入库短缺（Shortage）罚款、订单履约违规费用以及延迟/取消提货产生的违约罚金，为品牌商显著提升了运营效率和盈利水平。'
      },
      {
        title: 'VC业务存在账期，资金周转压力大？',
        painSpot: '痛点',
        ism: 'HARMONY 解决方案',
        url: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/challenge/challenge_3_576x480.png',
        painSpotText: `深圳某类目品牌商，单 ASIN 年营收1000万美金，亚马逊 VC 账期对公司现金流造成较大压力。`,
        ismText: 'HARMONY 提供了灵活的金融解决方案，能够实现最快 T+1 天的回款，这大大提升了品牌商的资金周转率。在灵活的金融解决方案下，合作顺利开展，并且在合作的第一年，实现销量的 150% 增长。'
      }
    ],
    advantageTitle: '铸就领先的解决方案',
    advantageTitleColor: '五大优势',
    advantages: [
      {
        title: '整合渠道资源',
        info: `<p>链接 Amazon VC 等优质渠道，覆盖全球市场。</p><p>线上线下分销渠道一站式整合，品牌多维曝光。</p><p>标准化 SOP，接入渠道更高效。</p>`,
        image: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/advantage/advantage_1_416x400.png',
        icon: ''
      },
      {
        title: '智慧仓储物流',
        info: `<p>多重选择，提供各个地区丰富仓储资源。</p><p>高效专业的物流系统支持，开放 API 接口。</p><p>自营云仓，提供定制化&灵活的仓储物流方案。</p>`,
        image: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/advantage/advantage_2_416x400.png',
        icon: ''
      },
      {
        title: '数智引擎助力运营决策',
        info: `<p>智能系统实现数智化运营，为企业降本增效。</p><p>AI 驱动的市场趋势分析，捕捉市场先机。</p><p>多维度数据分析，助力运营决策。</p>`,
        image: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/advantage/advantage_3_416x400.png',
        icon: ''
      },
      {
        title: '全方位专业支持',
        info: `<p>多年官方渠道合作经验，专属经理为运营赋能。</p><p>系统化培训课程，快速上手启动业务。</p><p>专业团队高效服务，提供业务全流程疑问解答。</p>`,
        image: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/advantage/advantage_4_416x400.png',
        icon: ''
      }
    ],
    sellerTitle1: '成为跨境卖家的',
    sellerTitle2: '共同选择',
    sellerInfos: [
      {
        value: 'Electronics',
        name: 'Anna',
        brandName: '家具品牌卖家',
        info: `<span>通过 HARMONY 的 VC 渠道长 BD 的优势以及流量权重，</span><span style="color: #980608;">我们平均月销量由原来一天5~10单增长到现在一天50~100单，远超原本的预期</span><span>。 HARMONY 提供的全流程解决方案，帮我们提升了业务流转效率，降低了很多隐性运营成本。</span>`,
        // info: `<span>通过 QUANTORA 的 VC 渠道长 BD 的优势以及流量权重，</span><span style="color: #efb4ff;
        //     background: linear-gradient(90deg, #6d9dff, #efb4ff);
        //     -webkit-background-clip: text;
        //     -webkit-text-fill-color: transparent;">我们平均月销量由原来一天1~2单增长到现在一天10~20单，远超原本的预期</span><span>。 SPOTTER 提供的全流程解决方案，帮我们提升了业务流转效率，降低了很多隐性运营成本。</span>`,
        dataTitle: '月销量增长',
        data: '10倍增长',
        translateX: '0',
        userUrl:'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/foreStatic/quantora/assets/images/home/3c/user.png',
        briefIntroduction: '成功跻身头部阵营，市场竞争力大幅提升。'
      }
      // {
      //   value: 'Home & Kitchen',
      //   name: 'William',
      //   brandName: '华中某大件家具卖家',
      //   info: `之前做 FBM 只有双仓备货，和 HARMONY 合作后，使用 SPOTTER 头程+海外仓服务，实现全美多仓备货，转入 VC 后选择 DF 订单形式，<span style="color: #efb4ff;
      //             background: linear-gradient(90deg, #6d9dff, #efb4ff);
      //             -webkit-background-clip: text;
      //             -webkit-text-fill-color: transparent;">产品总体销量同比增长 25%</span> ，多条链接进入小类目前 100。`,
      //   dataTitle: '小类目 BSR',
      //   data: 'No.1',
      //   translateX: '10vw',
      //   userUrl:'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/direct/test/2025-08-14/3960206916/175014830090914959.png',
      //   url:'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/direct/test/2025-08-14/3960206916/175014830090914959.png',
      //   briefIntroduction: '主力产品拿下小类目 BSR 第1 名，多条链接进入小类目前 100。'
      // },
      // {
      //   value: 'Outdoors',
      //   name: 'Grace',
      //   brandName: '华东品牌卖家',
      //   info: `和 HARMONY 合作了 2 年，<span style="color: #efb4ff;
      //             background: linear-gradient(90deg, #6d9dff, #efb4ff);
      //             -webkit-background-clip: text;
      //             -webkit-text-fill-color: transparent;">项目营收环比去年增长了175%</span>，通过 VC 的 BD 资源，主推款产品在大促期间销量实现 9 倍的涨幅，突破了我们原本的业务瓶颈。`,
      //   dataTitle: '单品牌年 GMV',
      //   data: '$20M',
      //   translateX: '-10vw',
      //   userUrl:'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/direct/test/2025-08-14/3960206916/175014830090914959.png',
      //   url:'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/direct/test/2025-08-14/3960206916/175014830090914959.png',
      //   briefIntroduction: '单品牌年 GMV 达 2000 万美金。'
      // },
      // {
      //   value: 'Personal Care',
      //   name: 'James',
      //   brandName: '华南地区品牌卖家',
      //   info: `SC 类目竞争已经进入白热化，广告成本的上升导致我们几乎没有利润空间。VC 的长周期 BD 和自然流量有效的缓解了广告的高额投放，<span style="color: #efb4ff;
      //             background: linear-gradient(90deg, #6d9dff, #efb4ff);
      //             -webkit-background-clip: text;
      //             -webkit-text-fill-color: transparent;">广告成本下降 5-8%</span>，为我们持续盈利提供了有效的保障。`,
      //   dataTitle: '广告成本下降',
      //   data: '8%',
      //   translateX: '-20vw',
      //   userUrl:'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/direct/test/2025-08-14/3960206916/175014830090914959.png',
      //   url:'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/uploads/direct/test/2025-08-14/3960206916/175014830090914959.png',
      //   briefIntroduction: '广告成本下降5-8%'
      // },
    ],
    newEcologyTitle1: '携手',
    newEcologyTitle1Color: '全球伙伴',
    newEcologyTitle2: '构建跨境出海新生态',
    tailTitle1: '准备好迎接前所未有的高速增长了吗？',
    tailTitle2: '选择 HARMONY 让您的跨境业务，先人一步',
    pageFootModule: {
      title: '国内领先的 B2B 跨境渠道分销一站式平台',
      solution: '解决方案',
      businessModel: '业务模式',
      settled: '入驻',
      entryGuide: '入驻指南',
      about: '关于',
      aboutUs: '关于我们',
      contact: '联系我们',
      email: '邮箱',
      wx: '微信扫码咨询',
    }
  },
  about: {
    title: '关于',
    description: '这是一个使用Vue.js构建的多语言网站'
  },
  navigation: {
    home: 'HARMONY',
    about: '关于',
    language: '语言',
    languageChose: '语言选择',
    en: '英文',
    zh: '中文',
    ja: '日文',
    getScheme: '获取方案',
    solution: '解决方案',
    joinType: '入驻方式',
    joinNow: '立即入驻',
    aboutUs: '关于我们',
    businessModel: '业务模式'
  },
  notFound: {
    title: '页面不存在',
    message: '您正在寻找的页面不存在',

  },
}
